import { oreillyPlaylistSC } from '../DataAndAPIs/Links'
import { learningObjectivesIntro, initialPost, estimated } from './AL00000Sprint00'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { scheduleLinkV2 } from '../DataAndAPIs/Links'
import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'
import { capstoneSprint6Link } from '../Activities/ClassProduct'
import { classProductPresentationLink } from '../Activities/ClassProduct'
import { getClassSectionID } from '../DataAndAPIs/ClassSections'

export const al49200Sprint06 = () => {
	const sprint = 6
	return ( <div>	
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p><em>Welcome to sprint {sprint}.</em> Stay focused on delivering stories to your production environment that add the most value for customers, and 
		remember that being “done” with a something small and delivering it to production is <em>immensely</em> more valuable 
		than being “almost done” with something great.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Continuously improve sprint planning by successfully completing sprint {sprint} planning within the first three days of the sprint</li>
			<li>Continuously improve your Minimum Viable Product (MVP) plan and implementation {sprint}</li>
			<li>Continuously improve “done” and keep it in mind at all times while you are working on features</li>
			<li>Inspire your Next Generation (NG) delivery team become proficient as you will be turning the product over to them in sprint 7</li>
		</ul>

		{list49200Sprint06(sprint)}
	</div> )
}

export const list49200Sprint06 = (sprint) => {
	return ( <div>
		<p>Below is our activities list which, according to our {scheduleLinkV2(getClassSectionID(), sprint)}, needs to be 
		completed by {sprintEndDateWithoutTime(sprint-1)}:</p>
		<ol>
			<li>Complete {capstoneSprint6Link()} Requirements 0, 1, and 2</li>
			<li>Review what is expected from {classProductPresentationLink()}</li>
			<li>Within {oreillyPlaylistSC()} review “Essential Scrum” looking for topics that your team can focus on improving</li>
			{initialPost(sprint)}
			<li>Complete {capstoneSprint6Link()} {estimated('14 hours per team member')}</li>
			<li><em>Submit Discussion, Writing Assignment, Lab, and Reflection</em></li>
		</ol>
	</div> )
}

// Certified for SP25 on April 5, 2025


